export default "__VITE_ASSET__BvFXJ6lv__"